module.exports = __webpack_public_path__ + "img/jx-0001-19-1-1.prt.ce19fc51.jpg";